var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "divBox",
    },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "form-boder-padding",
              attrs: {
                rules: _vm.rules,
                model: _vm.formData,
                "label-width": "130px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "新用户赠送：", prop: "newUserCashAmount" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      step: 0.01,
                      "controls-position": "right",
                      "step-strictly": "",
                      placeholder: "请输入金额",
                    },
                    model: {
                      value: _vm.formData.newUserCashAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "newUserCashAmount", $$v)
                      },
                      expression: "formData.newUserCashAmount",
                    },
                  }),
                  _vm._v("元 "),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v("新用户登录赠送的现金红包金额"),
                  ]),
                ],
                1
              ),
              _vm._l(_vm.formData.walletRangeConfigs, function (item, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _c("h2", { staticClass: "form_label mb10" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "每日红包类型：" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择每日红包类型" },
                            model: {
                              value: item.packetType,
                              callback: function ($$v) {
                                _vm.$set(item, "packetType", $$v)
                              },
                              expression: "item.packetType",
                            },
                          },
                          _vm._l(_vm.typeOptions, function (itm) {
                            return _c("el-option", {
                              key: itm.value,
                              attrs: { label: itm.label, value: itm.value },
                            })
                          }),
                          1
                        ),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v("用户每日参与活动后，所赠送的红包类型"),
                        ]),
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "红包上限：" } }, [
                      item.packetType === 1 || item.packetType === 3
                        ? _c(
                            "div",
                            { staticClass: "acea-row mb10" },
                            [
                              _c("div", [_vm._v("现金红包个数：")]),
                              _c("el-input-number", {
                                attrs: {
                                  min: 1,
                                  step: 1,
                                  "controls-position": "right",
                                  "step-strictly": "",
                                  placeholder: "请输入个数",
                                },
                                model: {
                                  value: item.dailyLimit,
                                  callback: function ($$v) {
                                    _vm.$set(item, "dailyLimit", $$v)
                                  },
                                  expression: "item.dailyLimit",
                                },
                              }),
                              _c("div", [_vm._v("个，限定总金额：")]),
                              _c("el-input-number", {
                                attrs: {
                                  min: 0,
                                  step: 0.01,
                                  "controls-position": "right",
                                  "step-strictly": "",
                                  placeholder: "请输入金额",
                                },
                                model: {
                                  value: item.cashAmountLimit,
                                  callback: function ($$v) {
                                    _vm.$set(item, "cashAmountLimit", $$v)
                                  },
                                  expression: "item.cashAmountLimit",
                                },
                              }),
                              _c("div", [_vm._v("元")]),
                            ],
                            1
                          )
                        : _vm._e(),
                      item.packetType === 2 || item.packetType === 3
                        ? _c(
                            "div",
                            { staticClass: "acea-row" },
                            [
                              _c("div", [_vm._v("积分红包个数：")]),
                              _c("el-input-number", {
                                attrs: {
                                  min: 1,
                                  step: 1,
                                  "controls-position": "right",
                                  "step-strictly": "",
                                  placeholder: "请输入个数",
                                },
                                model: {
                                  value: item.pointsDailyLimit,
                                  callback: function ($$v) {
                                    _vm.$set(item, "pointsDailyLimit", $$v)
                                  },
                                  expression: "item.pointsDailyLimit",
                                },
                              }),
                              _c("div", [_vm._v("个，限定总积分：")]),
                              _c("el-input-number", {
                                attrs: {
                                  min: 0,
                                  step: 1,
                                  "controls-position": "right",
                                  "step-strictly": "",
                                  placeholder: "请输入积分",
                                },
                                model: {
                                  value: item.pointsLimit,
                                  callback: function ($$v) {
                                    _vm.$set(item, "pointsLimit", $$v)
                                  },
                                  expression: "item.pointsLimit",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "from-tips" }, [
                        _vm._v(
                          "用户每日参与活动后，所赠送的红包总数、每日红包抽奖时的总现金额度、每日红包抽奖时的总积分额度"
                        ),
                      ]),
                    ]),
                  ],
                  1
                )
              }),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: [
                            "platform:system:user:withdraw:config:update",
                          ],
                          expression:
                            "['platform:system:user:withdraw:config:update']",
                        },
                      ],
                      attrs: { type: "primary", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formData")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }